<template>
  <el-dialog
    :title="$t('title')"
    :visible.sync="dialogVisible"
    size="mini"
    class="bifactor-dialog"
    @close="handleClose"
  >
    <el-alert
      v-if="pageType === 'secondary_sms'"
      :title="$t('alertTitleMobile')"
      type="info"
      show-icon
    />
    <el-alert
      v-if="pageType === 'secondary_password'"
      :title="$t('alertTitleAccount')"
      type="info"
      show-icon
    />

    <el-form
      v-show="pageType === 'secondary_sms'"
      ref="formMobile"
      class="form"
      :model="formMobile"
      :rules="rulesMobile"
    >
      <el-form-item prop="mobile">
        <el-input v-model="formMobile.mobile" :disabled="true" />
      </el-form-item>
      <el-form-item prop="captchaCode">
        <el-col :span="17">
          <el-input
            v-model="formMobile.captchaCode"
            class="captcha-block"
            :placeholder="$t('codeImgPlaceholder')"
            @keyup.enter.native="handleMobile"
          />
        </el-col>
        <el-col class="line" :span="1"> -</el-col>
        <el-col :span="6" class="captcha-img">
          <img
            :src="captchaUrl"
            style="width: 100%; height: 32px"
            @click="setCaptcha"
          >
        </el-col>
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-col :span="17">
          <el-input
            ref="mobileVerifyCode"
            v-model="formMobile.verifyCode"
            class="captcha-block"
            :placeholder="$t('codeMobilePlaceholder')"
            @keyup.enter.native="accountLogin"
          />
        </el-col>
        <el-col class="line" :span="1"> -</el-col>
        <el-col :span="6" class="captchInfo-btn">
          <el-button class="button-item" @click="checkCaptcha">{{
            captchInfo
          }}</el-button>
        </el-col>
      </el-form-item>
      <el-row>
        <el-button
          class="login-btn"
          size="large"
          type="primary"
          @click="mobileLogin"
        >{{ $t('login') }}</el-button>
      </el-row>
    </el-form>

    <el-form
      v-show="pageType === 'secondary_password'"
      ref="formAccount"
      class="form"
      :model="formAccount"
      :rules="rulesAccount"
    >
      <el-form-item prop="account">
        <el-input v-model="formAccount.account" :disabled="true" />
      </el-form-item>
      <el-form-item prop="password">
        <el-input
          v-model="formAccount.password"
          class="captcha-block"
          type="password"
          :placeholder="$t('passwordPlaceholder')"
          @keyup.enter.native="accountLogin"
        />
      </el-form-item>
      <el-row>
        <el-button
          class="login-btn"
          size="large"
          type="primary"
          @click="accountLogin"
        >{{ $t('login') }}</el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<i18n src="../locales/views/bifactor.json"></i18n>

<script>
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

export default {
  name: 'Bifactor',
  components: {},
  props: {
    pageType: String,
    mobile: String,
    customCode: String,
    callbackUrl: String,
    visible: Boolean,
    tenantId: [String, Number]
  },
  data () {
    return {
      dialogVisible: false,
      captchaUrl: '',
      countDown: 60,
      formRule: [],
      captchInfo: this.$t('getMobileCaptcha'),
      formMobile: {
        mobile: '',
        captchaCode: '',
        verifyCode: ''
      },
      rulesMobile: {
        captchaCode: [
          {
            required: true,
            message: this.$t('rulesMessage.captchaCode'),
            trigger: 'blur'
          }
        ],
        verifyCode: [
          {
            required: true,
            message: this.$t('rulesMessage.verifyCode'),
            trigger: 'blur'
          }
        ]
      },
      rulesAccount: {
        password: [
          {
            required: true,
            message: this.$t('rulesMessage.password'),
            trigger: 'blur'
          }
        ]
      },
      formAccount: {
        account: '',
        password: ''
      }
    }
  },
  computed: {},
  watch: {
    visible (newVal) {
      if (newVal) {
        this.dialogVisible = newVal
        if (this.pageType === 'secondary_sms') {
          // this.resetForm('formMobile')
          this.setCaptcha()
          this.formMobile.mobile = this.mobile
        } else {
          // this.resetForm('formAccount')
          this.formAccount.account = this.mobile
        }
      }
    }
  },
  async created () {},
  mounted () {},
  methods: {
    handleClose (done) {
      this.pageType === 'secondary_sms'
        ? this.resetForm('formMobile')
        : this.resetForm('formAccount')
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    resetForm (formName) {
      if (this.$refs[formName] !== undefined) {
        this.$refs[formName].resetFields()
      }
    },
    setCaptcha () {
      this.captchaUrl = '/cas/identity/extend/captcha?t=' + new Date().getTime()
    },
    async checkCaptcha () {
      const res = await this.$api.bifactor.checkCaptcha(
        this.formMobile.mobile,
        this.formMobile.captchaCode
      )

      if (res.success) {
        this.captchInfo = this.$t('sending')
        this.captchInfo = '- ' + this.countDown + 's'
        this.setVerifyCodeTime()
      } else {
        this.$message.error(res.message)
      }
    },
    setVerifyCodeTime () {
      const timeoutId = setInterval(() => {
        this.countDown--
        this.captchInfo = '- ' + this.countDown + 's'
        if (this.countDown < 1) {
          clearInterval(timeoutId)
          this.captchInfo = this.$t('getMobileCaptcha')
          this.countDown = 60
        }
      }, 1000)
    },
    async login (params) {
      const res = await this.$api.bifactor.login(params)

      if (res.success) {
        window.location.href = `${res.data}&redirectUrl=${this.callbackUrl ||
          ''}`
      } else {
        this.$message.error(res.errorMsg)
      }
    },
    async handleMobile () {
      if (this.formMobile.captchaCode) {
        !this.formMobile.captchaCode
          ? this.$refs.mobileVerifyCode.focus()
          : this.mobileLogin()
      }
    },
    async mobileLogin () {
      await this.$refs.formMobile.validate()

      const params = {
        type: 'sms',
        account: this.formMobile.mobile,
        verifyCode: this.formMobile.verifyCode
      }
      await this.login(params)
    },
    encryptPassword (password) {
      var encryptor = new JSEncrypt() // 创建加密对象实例
      var pubKey = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCWO5bv4RnMb5IpHWfjauu4Ut/jYYD4JvUcbuII2EguPatcKtqJnRWuJ7VQytCH5Zn3K/2uqss3kqYde9CjsgEfCSK2yQ2rLe+ergqdjLSJpNmcwvBQRXB/LvXKD7ug4J6UNZ3sSeTpamxV4zE8zFsJxmGTZweTFmMnNeK3pYjb5wIDAQAB-----END PUBLIC KEY-----'
      encryptor.setPublicKey(pubKey)// 设置公钥
      return encryptor.encrypt(password)
    },
    async accountLogin () {
      await this.$refs.formAccount.validate()
      const params = {
        type: 'password',
        account: this.formAccount.account,
        password: this.encryptPassword(this.formAccount.password),
        tenantId: this.tenantId
      }

      await this.login(params)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.bifactor-dialog {
  .form {
    margin-top: 16px;
  }
  .captcha-block {
    margin-right: 8px;
  }
  .captcha-img {
    height: 32px;
  }
  .line {
    padding-left: 4px;
  }
  .button-item {
    width: 100%;
    padding: 0;
  }
  .login-btn {
    width: 100%;
  }
  .InfoBlock {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    .icon {
      font-size: 24px;
      margin-right: 8px;
      color: $--color-primary;
    }
    .content {
      color: $--color-text-regular;
    }
    .info-down-middle {
      color: $--color-primary;
      cursor: pointer;
    }
  }
  ::v-deep .el-dialog {
    top: 130px;
    width: 400px !important;
  }
  ::v-deep .captchInfo-btn {
    .el-button {
      padding: 0 !important;
    }
  }
}
</style>
